// Traducciones en español (idioma por defecto). Organizadas por sección de la landing.
export const es = {
  nav: {
    features: 'Qué es',
    map: 'El mapa',
    join: 'Únete',
    explore: 'Explorar el mapa',
  },
  hero: {
    eyebrow: 'Mapa colaborativo de arqueología',
    title_1: 'Descubre nuestro pasado',
    title_2: 'interactivamente',
    subtitle:
      'Calzadas romanas, villas, castros, dólmenes y miliarios. Un mapa abierto donde exploramos, documentamos y compartimos los restos arqueológicos que nos rodean.',
    cta_primary: 'Explorar el mapa',
    cta_secondary: 'Saber más',
    scroll: 'Desliza para descubrir',
  },
  stats: {
    coverage: 'Cobertura',
    coverage_value: 'España y el mundo',
    layers: 'Capas del IGN',
    layers_value: 'LIDAR · Ortofotos · Vuelo Americano',
    open: 'Proyecto',
    open_value: 'Abierto y colaborativo',
  },
  features: {
    title: 'El patrimonio, al alcance de un clic',
    subtitle:
      'Bestigium reúne en un solo mapa lo que durante siglos quedó disperso. Explóralo capa a capa.',
    interactive_title: 'Mapa interactivo',
    interactive_text:
      'Navega sobre OpenStreetMap con zoom fluido y mapas de calor. Cada resto, geolocalizado y a tu alcance.',
    layers_title: 'Capas del IGN',
    layers_text:
      'Activa LIDAR, ortofotos y el Vuelo Americano para detectar estructuras ocultas bajo el terreno (España).',
    collaborative_title: 'Colaborativo',
    collaborative_text:
      'Cualquiera puede añadir un yacimiento, documentarlo con fotos y comentar los hallazgos de la comunidad.',
    categories_title: 'Por categorías',
    categories_text:
      'Calzadas, villas, castros, dólmenes, miliarios y mucho más, cada tipo con su propio icono en el mapa.',
  },
  map: {
    title: 'Cada punto, una historia',
    subtitle:
      'Pincha un marcador y accede a su descripción, fuentes académicas, fotografías y la traza sobre el terreno.',
    pin_calzada: 'Calzada romana',
    pin_villa: 'Villa',
    pin_castro: 'Castro',
    pin_dolmen: 'Dolmen',
    pin_miliario: 'Miliario',
  },
  categories: {
    title: 'Qué vas a encontrar',
    list: 'Calzadas · Villas · Castros · Dólmenes · Miliarios · Puentes · Acueductos · Necrópolis · Termas · Murallas',
  },
  cta: {
    title: 'Súmate a la exploración',
    subtitle:
      'El pasado no es de los museos: es de todos. Abre el mapa y empieza a descubrir lo que tienes cerca.',
    button: 'Explorar el mapa',
  },
  footer: {
    tagline: 'El mapa colaborativo de nuestro pasado.',
    made: 'Hecho con cariño para quienes aman la historia.',
    rights: 'Todos los derechos reservados.',
  },
  // <head> de la página (title, description, og:*, JSON-LD): lo aplica el
  // prerender con localizeHead() en cada versión de idioma.
  meta: {
    title: 'Bestigium — Descubre nuestro pasado interactivamente',
    description:
      'Descubre nuestro pasado interactivamente. Bestigium es el mapa colaborativo de restos arqueológicos: calzadas romanas, villas, castros, dólmenes y miliarios.',
    og_description:
      'Mapa colaborativo de restos arqueológicos. Explora, documenta y comparte el patrimonio que nos rodea.',
    og_image_alt: 'Bestigium — Mapa colaborativo de restos arqueológicos',
    ld_description:
      'Mapa colaborativo de restos arqueológicos: calzadas romanas, villas, castros, dólmenes y miliarios. Explora, documenta y comparte el patrimonio que nos rodea.',
  },
  lang: {
    label: 'Idioma',
    es: 'ES',
    en: 'EN',
  },
} as const;
